import "../App.css";

function Header() {
  return (
    <div className="App-header">
      <div>My Todo List</div>
      <div>React</div>
    </div>
  );
}

export default Header;
